import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import { getAccountTypes } from "../../crud/auth.crud";
import {
  Portlet,
  PortletBody,
} from "../../partials/content/Portlet";
import QuickStatsChart from "../../widgets/QuickStatsChart";
import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";

export default class Account extends React.Component {
  state = {
    accountTiers:[],
    
  }

  
  componentDidMount()
  {
    
    
    getAccountTypes().then(response => response.data)
    .then((data) => {
       
      this.setState({ accountTiers: data })
      //console.log(this.state.users)
     })
  
    
  }
  render() {
    return (
      <>

        

        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Subscription Tiers" jsCode="true" createPath="/createtier">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      
                      <th>Tier</th>
                      <th>Description</th>
                      <th>Banner Display Time</th>
                      <th>Allocated Storage</th>
                      <th>Allocated Users</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.accountTiers.map((tier) => (
                    <tr>
                     
                      <td>{tier.accountTypeName}</td>
                      <td>{tier.typeDescription}</td>
                      <td>{tier.bannerDisplayTime + ' seconds'}</td>
                      <td>{tier.allocatedStorage}</td>
                      <td>{tier.allocatedUsers}</td>
                      <td>
                         
                          <Link  to={{pathname:"/edittier", data: {accountType:tier}}}>
                           <Tooltip
                                    title="Edit Tier" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
